import React from 'react';
import { useRef } from 'react';
import DatePicker from 'react-datepicker';
import calender from '../assets/images/calendar.png';

function Calendar({ selected, onChange, name, id, errors, setDate, disabled, isClearable = true }) {
    const datepickerRef = useRef(null);
   
  return (
    <><div className="d-flex date-picker-wrapper">
          <div>
              <DatePicker
                  selected={selected}
                  dateFormat="MM/dd/yyyy"
                  autoComplete='off'
                  className="datepicker form-control hasDatepicker" id={id} name={name}
                  onChange={(date) => {
                    setDate(date);
                    if (date) {
                      const mm = String(date.getMonth() + 1).padStart(2, '0');
                      const dd = String(date.getDate()).padStart(2, '0');
                      const yyyy = String(date.getFullYear());
                      const formatted = `${mm}/${dd}/${yyyy}`;
                      onChange({ target: { name, value: formatted } });
                    } else {
                      onChange({ target: { name, value: '' } });
                    }
                  }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      'Backspace','Delete','Tab','ArrowLeft','ArrowRight','Home','End','/',
                    ];
                    const isNumber = e.key >= '0' && e.key <= '9';
                    const isAllowed = isNumber || allowedKeys.includes(e.key);
                    if (!isAllowed) {
                      e.preventDefault();
                      return;
                    }
                    const input = e.currentTarget;
                    const value = input.value || '';
                    const selectionStart = input.selectionStart ?? value.length;
                    const selectionEnd = input.selectionEnd ?? value.length;
                    const isReplacing = selectionStart !== selectionEnd;
                    const futureLength = isReplacing
                      ? value.length - (selectionEnd - selectionStart) + 1
                      : value.length + 1;
                    if ((isNumber || e.key === '/') && futureLength > 10) {
                      e.preventDefault();
                    }
                  }}
                  onChangeRaw={(e) => {
                    if (!e || !e.target || typeof e.target.value !== 'string') {
                      return;
                    }
                    const raw = e.target.value;
                    const cleaned = raw.replace(/[^0-9/]/g, '');
                    const digitsOnly = cleaned.replace(/\D/g, '').slice(0, 8);

                    // Determine intended segment lengths from typed slashes
                    const parts = cleaned.split('/');
                    const monthLenHint = Math.min((parts[0] || '').replace(/\D/g, '').length, 2);
                    const dayLenHint = Math.min((parts[1] || '').replace(/\D/g, '').length, 2);

                    const firstSlashTyped = cleaned.includes('/');
                    const secondSlashTyped = firstSlashTyped && cleaned.indexOf('/', cleaned.indexOf('/') + 1) !== -1;

                    const totalDigits = digitsOnly.length;
                    const monthLen = Math.min(monthLenHint || Math.min(2, totalDigits), 2);
                    const dayAvailable = Math.max(totalDigits - monthLen, 0);
                    const dayLen = Math.min(dayLenHint || Math.min(2, dayAvailable), 2);
                    const yearAvailable = Math.max(totalDigits - monthLen - dayLen, 0);
                    const yearLen = Math.min(4, yearAvailable);

                    const month = digitsOnly.slice(0, monthLen);
                    const day = digitsOnly.slice(monthLen, monthLen + dayLen);
                    const year = digitsOnly.slice(monthLen + dayLen, monthLen + dayLen + yearLen);

                    let formatted = month;
                    if (firstSlashTyped || dayLen > 0) {
                      formatted += '/';
                    }
                    formatted += day;
                    if ((secondSlashTyped || yearLen > 0) && (firstSlashTyped || dayLen > 0)) {
                      formatted += '/';
                    }
                    formatted += year;

                    e.target.value = formatted;
                  }}
                  onBlur={(e) => {
                    if (!e || !e.target || typeof e.target.value !== 'string') {
                      return;
                    }
                    const v = e.target.value || '';
                    const loose = v.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
                    if (!loose) {
                      e.target.value = '';
                      onChange({ target: { name, value: '' } });
                      setDate(null);
                      return;
                    }
                    const mm = parseInt(loose[1], 10);
                    const dd = parseInt(loose[2], 10);
                    const yyyy = parseInt(loose[3], 10);
                    if (!(mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31)) {
                      e.target.value = '';
                      onChange({ target: { name, value: '' } });
                      setDate(null);
                      return;
                    }
                    const dt = new Date(yyyy, mm - 1, dd);
                    if (
                      dt.getFullYear() !== yyyy ||
                      dt.getMonth() !== mm - 1 ||
                      dt.getDate() !== dd
                    ) {
                      e.target.value = '';
                      onChange({ target: { name, value: '' } });
                      setDate(null);
                      return;
                    }
                    const formatted = `${String(mm).padStart(2, '0')}/${String(dd).padStart(2, '0')}/${yyyy}`;
                    e.target.value = formatted;
                    setDate(dt);
                    onChange({ target: { name, value: formatted } });
                  }}
                  isClearable={isClearable}
                  disabled={disabled}
                  ref={datepickerRef}>
              </DatePicker>
          </div>
          <div className='date-picker-btn'>
              <button className="btn datepicker-button"
                  type="button"
                  data-target="#date_of_birth"
                  id="date-of-birth-btn"
                  onClick={() => {
                      datepickerRef.current.setOpen(true);
                  } }>
                  <img src={calender} className="img-fluid" width="20" height="20" alt="calender" />
              </button>
          </div>

      </div>{errors && <span className='errors'>{errors}</span>}</>

  )
}

export default Calendar
